import { render } from "./Messages.vue?vue&type=template&id=1bf5289a&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-1bf5289a"

export default script